import { theme } from '@contrast-security-inc/design-system-foundations'
import React from 'react'
import { useIntl } from 'react-intl'
import { getBgColorByGrade } from '../../../../../../components/grades/grade-badge'
import { Grade } from '../../../../helpers/ui-interfaces'
import { ScoreTile } from '../score-tile'
import { styles } from './styles'

interface Props {
  grade: Grade
  isPrivate?: boolean
}

export const ScoreSection = ({ grade, isPrivate = false }: Props) => {
  const intl = useIntl()

  return (
    <div className={styles.ScoreSection}>
      <ScoreTile grade={grade} isPrivate={isPrivate} />
      <div>
        {!isPrivate ? (
          <div
            className={styles.ScoreSectionPercentage}
            data-testid="score-section-progress-score"
          >
            {grade.score}/100
          </div>
        ) : (
          <div
            className={styles.ScoreSectionPrivate}
            data-testid="score-section-progress-private"
          >
            {intl.formatMessage({
              id: 'title_unknown'
            })}
          </div>
        )}
        <div className={styles.ScoreSectionPercentageProgressBar}>
          <div
            className={styles.ScoreSectionPercentageProgress}
            data-testid="score-section-progress"
            style={{
              width: isPrivate ? 100 : grade.score,
              backgroundColor: isPrivate
                ? theme.color.neutral40
                : theme.color[getBgColorByGrade(grade.value)]
            }}
          />
        </div>
      </div>
    </div>
  )
}
